import { readFloat32Array, readY } from "./readValues.js";
import { parseSubHeader, setXYAxis } from "./shared.js";
import { getYEncoding } from "./subfileLayout.js";
/**
 * Bytes of a subfile header.
 */
export const subHeaderLength = 32;
const halvedNote = 'subnpts is twice the number of points stored in a subfile (as written by Wasatch ENLIGHTEN); half of it was used';
/**
 * Reads the new-format subfile starting at a position, when it fits.
 * @param buffer - SPC buffer.
 * @param location - where the subfile is and how it is laid out.
 * @returns The subfile, or `undefined` when it does not fit.
 */
export function readSubfile(buffer, location) {
    const { position, limit, fileHeader, hasOwnX, commonX } = location;
    if (position + subHeaderLength > limit)
        return undefined;
    buffer.seek(position);
    const subHeader = parseSubHeader(buffer, location.textEncoding);
    const encoding = getYEncoding(subHeader.exponentY, fileHeader.exponentY, fileHeader.parameters);
    const pointSize = (hasOwnX ? 4 : 0) + encoding.bytesPerY;
    let numberPoints = hasOwnX
        ? subHeader.numberPoints
        : commonX.length;
    let end = position + subHeaderLength + pointSize * numberPoints;
    if (end > limit && hasOwnX && numberPoints % 2 === 0) {
        const halvedEnd = position + subHeaderLength + (pointSize * numberPoints) / 2;
        if (!isKnownBoundary(halvedEnd, location))
            return undefined;
        numberPoints /= 2;
        end = halvedEnd;
        encoding.notes.push(halvedNote);
    }
    if (end > limit)
        return undefined;
    const x = hasOwnX
        ? readFloat32Array(buffer, numberPoints)
        : commonX;
    const y = readY(buffer, numberPoints, encoding);
    const meta = {
        ...subHeader,
        exponent: encoding.exponent,
        isFloat: encoding.isFloat,
        index: 0,
    };
    const variables = setXYAxis(x, y, fileHeader, location.sortX, hasOwnX);
    return { meta, variables, end, notes: encoding.notes };
}
/**
 * Whether a halved subfile ends exactly where something else is known to
 * start: the end of the data area, the log block or the next subfile.
 * @param end - offset where the halved subfile ends.
 * @param location - where the subfile is.
 * @returns `true` when the halved size is confirmed by the layout.
 */
function isKnownBoundary(end, location) {
    const { limit, fileHeader, nextPosition } = location;
    return (end === limit ||
        (fileHeader.logOffset !== 0 && end === fileHeader.logOffset) ||
        end === nextPosition);
}
//# sourceMappingURL=readSubfile.js.map